/* eslint-disable react/prop-types */
import { useAuth } from '@frontegg/react';
import { toast } from '@insight-health-ai/roseate/components';
import { CopiesIcon } from '../../../../icons';
import { analytics } from 'src/services';
import { copyToClipboard, sanitizeSummaryAsText } from 'src/utils';

const CopySection = ({
  showCopyTooltip,
  copyTooltipPosition,
  onMouseOver,
  onMouseLeave,
  copiedSectionText,
  encounterId = null,
  copySectionRef,
  copySectionTitle = true,
}) => {
  const { user } = useAuth();
  if (!showCopyTooltip) {
    return null;
  }
  const handleClick = async () => {
    let sanitisedText = copiedSectionText;
    analytics.track(
      'Clicked Copy Section In Aura Encounters In Visit Section',
      {
        transcription: encounterId,
        email: user?.email,
      }
    );

    if (!sanitisedText || sanitisedText?.trim() === '') {
      toast.info('No data available to copy');
      return;
    }

    if (!copySectionTitle) {
      sanitisedText = sanitisedText.replace(
        /^<strong[^>]*>\|\s*[^<]*<\/strong>/,
        ''
      );
    }

    try {
      sanitisedText =
        typeof sanitisedText === 'string'
          ? sanitizeSummaryAsText(sanitisedText)
          : sanitisedText;

      await copyToClipboard(sanitisedText);

      toast.success('Copied to clipboard');
    } catch (error) {
      toast.error('Failed to copy medical notes');
    }
  };

  return (
    <span
      // eslint-disable-next-line react/no-unknown-property
      overlayClassName="custom-tooltip copy-tooltip"
      className="copy-tooltip flex cursor-pointer shadow-lg linked-evidence-float-button bg-[#00D090] hover:bg-[#059669] font-normal p-3 rounded-xl focus:outline-none focus:shadow-outline z-50"
      style={{
        position: 'fixed',
        left: `${copyTooltipPosition?.x - 2}px`,
        top: `${copyTooltipPosition?.y - 8}px`,
      }}
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
      onClick={handleClick}
      ref={copySectionRef}
    >
      <CopiesIcon /> <span className="text-white">Copy Section</span>
    </span>
  );
};

export default CopySection;
